import { render } from "./Sparkles.vue?vue&type=template&id=6367bc3e&bindings={}"
import script from "./Sparkles.vue?vue&type=script&lang=ts"
export * from "./Sparkles.vue?vue&type=script&lang=ts"
script.render = render

export default script